import { assertNever } from 'owa-assert';
import { AttachmentPreviewMethod } from 'owa-attachment-data';

export default function attachmentPreviewMethodToString(
    previewMethod: AttachmentPreviewMethod
): string {
    switch (previewMethod) {
        case AttachmentPreviewMethod.Unsupported:
            return 'Unsupported';
        case AttachmentPreviewMethod.Image:
            return 'Image';
        case AttachmentPreviewMethod.MailItem:
            return 'MailItem';
        case AttachmentPreviewMethod.CalendarEvent:
            return 'CalendarEvent';
        case AttachmentPreviewMethod.Wac:
            return 'Wac';
        case AttachmentPreviewMethod.SuiteExtensions:
            return 'SuiteExtensions';
        case AttachmentPreviewMethod.Audio:
            return 'Audio';
        case AttachmentPreviewMethod.Text:
            return 'Text';
        case AttachmentPreviewMethod.NativeView:
            return 'NativeView';
        case AttachmentPreviewMethod.GoogleDoc:
            return 'GoogleDoc';
        case AttachmentPreviewMethod.PdfJs:
            return 'PdfJs';
        case AttachmentPreviewMethod.ItemAttachment:
            return 'ItemAttachment';
        case AttachmentPreviewMethod.Video:
            return 'Video';
        default:
            return assertNever(previewMethod);
    }
}
